import Vue from 'vue'
import pdfvuer from 'pdfvuer'

export default Vue.component('pdf-viewer', {
  mixins: [pdfvuer],
  beforeDestroy() {
    var self = this
    if (self.pdfViewer) {
      self.pdfViewer.destroy()
      self.pdfViewer = null
    }
  }
})
